import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { EXTRA_INFO_CUSTOMER_HISTORY_ROUTE } from '~/constants/routes';
import { useAppContent, useAppSelector, useExtraInfo } from '~/hooks';
import { selectIsReferralCostco } from '~/selectors/selectAppDetails';
import { SimpleQuestionAnswer } from '~/types/enums';
import { formatMobile } from '~/utils';
import { formatABN } from '~/utils/formatAbn';

const ReviewExtraInfo: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.extraInfo' });

  const isCostco = useAppSelector(selectIsReferralCostco);
  const {
    claimCount,
    applied,
    abn,
    noAbn,
    businessName,
    firstName,
    lastName,
    email,
    mobile,
    partnerMembershipNumber,
  } = useExtraInfo();

  const extraInfoReviewList = [
    {
      label: getTextContent('claimCount'),
      data: claimCount,
    },
    {
      label: getTextContent('appliedEvents'),
      data: applied ? SimpleQuestionAnswer.Yes : SimpleQuestionAnswer.No,
    },
    {
      label: getTextContent('abn'),
      data: noAbn ? getTextContent('noAbn') : abn && formatABN(abn),
    },
    {
      label: getTextContent('businessName'),
      data: businessName,
    },
    {
      label: getTextContent('name'),
      data: `${firstName ?? ''} ${lastName ?? ''}`,
    },
    {
      label: getTextContent('mobileNumber'),
      data: mobile && formatMobile(mobile),
    },
    {
      label: getTextContent('email'),
      data: email,
    },
  ];

  if (isCostco)
    extraInfoReviewList.push({
      label: getTextContent('partnerMembershipNumber'),
      data: partnerMembershipNumber,
    });

  return (
    <ReviewList
      list={
        extraInfoReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={getTextContent('title')}
      editRoute={EXTRA_INFO_CUSTOMER_HISTORY_ROUTE}
    />
  );
};

export default ReviewExtraInfo;
